<template>
  <el-dialog
    title="工作记录"
    :visible.sync="workDialogVisible"
    :before-close="workHandleClose"
    width="800px"
    center
    append-to-body
  >
    <el-form :model="workForm" class="demo-form-inline">
      <el-form-item label="名称/编号">
        <el-col :span="17">
          <el-input v-model="workForm.input" placeholder="请输入名称/编号"></el-input>
        </el-col>
        <el-col :span="1">&nbsp;</el-col>
        <el-col :span="2">
          <el-button type="primary" @click="onSubmit">查询</el-button>
        </el-col>
      </el-form-item>
    </el-form>
    <el-scrollbar style="height: 100%;">
      <div style="height: 400px;">
        <el-row v-for="(c,index) in works" :key="index" style="margin-top: 3px;">
          <el-col :span="24">
            <el-card :body-style="{ padding: '0px'}" shadow="hover">
              <div style="padding: 14px;">
                <div>
                  <span v-html="delHtmlTag(c.INFO)"></span>
                  <div class="bottom clearfix">
                    <table style="width:100%;">
                      <tr>
                        <td>
                          <time class="time">
                            时间：
                            {{c.CREATETIME|timeFormater}}
                            &nbsp;&nbsp;|&nbsp;&nbsp;
                            创建人：
                            {{c.CREATEUSERNAME}}
                          </time>
                        </td>
                        <td style="width:90px;line-height:30px">
                          <el-button
                            type="text"
                            class="button"
                            style="color:#6aca5d"
                            @click="sureWork(c.INFO)"
                          >选中</el-button>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>
    </el-scrollbar>
    <span slot="footer" class="dialog-footer">
      <!--<el-button @click="workDialogVisible = false">取 消</el-button>-->
      <el-button type="primary" @click="workDialogVisible = false">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {
  getTaskSummaryByUserId,
  getAllTaskSummaryByTaskId,
  GetAllRecordsByUserID,
  UploadFiles,
  GetFileInfoByTaskId,
  MergeFile
} from "@/api/modules/basicData/task.js";
import { Linq, DateFormat, TimeFormat } from "@/util/common";
import { mapState } from "vuex";
export default {
  data() {
    return {
      workDialogVisible: false,
      works: [],
      workForm: {
        input: ""
      }
    };
  },
  computed: {
    ...mapState({
      userId: state => state.task.userId,
    }),
  },
  created(){
    // this.getWorkRecord('')
  },
  methods: {
    sureWork(info) {
      let body = info + "<br/>";
      if (info) {
        this.$emit("getValue", body);
      }
      this.workDialogVisible = false;
    },
    workHandleClose(done) {
      done();
    },
    timeFormat(time) {
      return TimeFormat(time);
    },
    onSubmit() {
      this.getWorkRecord(this.workForm.input);
    },
    getWorkRecord(input) {
      GetAllRecordsByUserID(this.userId, input)
        .then(res => {
          this.works = res;
          console.log("记录", res);
        })
        .catch(err => {
          console.log("GetKnowledgeByParam error");
        });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
